import React, { useCallback, useState } from 'react';

const SQUARE_PATH = 'M1156.3,1122.1H643.9c-107,0-193.8-86.8-193.8-193.8V415.9c0-107,86.8-193.8,193.8-193.8h512.4 c107,0,193.8,86.8,193.8,193.8v512.4C1350.1,1035.3,1263.3,1122.1,1156.3,1122.1z';

const PLANE_PATH = 'M658.1,658.3l303-124.8c29.9-13,131.3-54.6,131.3-54.6s46.8-18.2,42.9,26c-1.3,18.2-11.7,81.9-22.1,150.9 l-32.5,204.2c0,0-2.6,29.9-24.7,35.1c-22.1,5.2-58.5-18.2-65-23.4c-5.2-3.9-97.5-62.4-131.3-91c-9.1-7.8-19.5-23.4,1.3-41.6 c46.8-42.9,102.7-96.2,136.5-130c15.6-15.6,31.2-52-33.8-7.8L780.3,724.6c0,0-20.8,13-59.8,1.3c-39-11.7-84.5-27.3-84.5-27.3 S604.8,679.1,658.1,658.3z';

const TelegramIcon = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {isHovered ? (
        <svg width="25" height="25" viewBox="450 222 900 900" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#36A6DE" d={SQUARE_PATH} />
          <path fill="white" d={PLANE_PATH} />
        </svg>
      ) : (
        <svg width="25" height="25" viewBox="450 222 900 900" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="white"
            d={`${SQUARE_PATH} ${PLANE_PATH}`}
          />
        </svg>
      )}
    </div>
  );
};

export default TelegramIcon;
